import {Fragment, React} from '@api';
import {ProductLikeDefinition} from '@api/graphql';
import {BuilderCard, useStores} from '@design-board/components'
import {usePdfStore} from '@modules/pdf'
import {Link, StyleSheet} from "@react-pdf/renderer";
import {nav} from '@stores'
import styled from '@react-pdf/styled-components'

const Column1 = styled.View`
  flex: 0 0 auto;
  width: 15vw;
  display: flex;
  flex-direction: column;
  padding-right: 10px;
  /*border-right-color: blue;
  border-right-style: solid;
  border-right-width: 2px;*/
`

const Column2 = styled.View`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  padding: 2% 0;
`

const ProductsContainer = styled.View`
  display: flex;
  flex-grow:1;
  flex-direction: column;
  flex-wrap: nowrap;
`

const ProductRow = styled.View`
  display: flex;
  flex-direction: row;
  flex-grow:1;
  overflow: hidden;
  flex-wrap: nowrap;
  align-content: space-between;
`

const CardContainer = styled.View`
  flex: 0 0 auto;
`

export interface ProductPageProps {
  products: ProductLikeDefinition[],
  itemsPerRow: number,
  group?: string
}

export const ProductPage = ({products, group, itemsPerRow}: ProductPageProps) => {
  const styles = StyleSheet.create(_.merge({}, {
    col1: {
      flex:          0,
      width:         '15%',
      display:       'flex',
      flexDirection: 'column',
      paddingRight:  10
    },

    watermarkContainer: {
      position: 'absolute',
    },
  }) as any)

  const {
      catalog: {groupBy: {isProductView, hierarchy}},
      vlp: {isVLPView}
    } = useStores(),
    {renderPage, reportTemplate, selectedPdfDocument: {size, orientation}} = usePdfStore()

  if (reportTemplate.renderProductPage) {
    return reportTemplate.renderProductPage({products, group, itemsPerRow}) as any
  }


  return renderPage(
    
    {
      pageTitle: isVLPView ? 'Colors' : 'Products',
      children:
                 <Fragment>
                   <ProductsContainer>
                     {true || isProductView ? _.chunk(products, itemsPerRow).map((rowProducts, row) =>
                       <ProductRow key={row}>
                         {rowProducts.map((p, c) =>
                           <CardContainer key={c} style={{marginLeft: c > 0 ? '4mm' : 0, marginBottom: '4mm'}}>
                             <Link src={nav.urlForObject(p)}>
                               <BuilderCard key={p.id}
                                                renderer='pdf'
                                                data={p}
                               />
                             </Link>
                           </CardContainer>)}
                       </ProductRow>) : null}
                   </ProductsContainer>
                 </Fragment>
    })
}



// WEBPACK FOOTER //
// ./src/modules/pdf/templates/ProductPage.tsx